<div #monitorRoot class="monitor-root monitor-mode" [class.is-fullscreen]="fullscreenActive">
    <div class="monitor-content" [class.monitor-fading]="fading">
        <app-resource-planning [monitorMode]="true" [monitorView]="view" [monitorWeekPage]="weekPage"
            [monitorYearPage]="yearPage" (monitorWeekPageCountChange)="weekPageCount = $event"
            (monitorYearPageCountChange)="yearPageCount = $event">
        </app-resource-planning>
        <div class="monitor-fullscreen-prompt" *ngIf="fullscreenBlocked && !fullscreenActive">
            <p>Der Browser benötigt einen Klick, um den Vollbildmodus zu starten.</p>
            <button mat-flat-button color="primary" (click)="enterFullscreen()">Vollbild starten</button>
            <button mat-button (click)="exitMonitor()">Zurück</button>
        </div>
    </div>